import {WEBSERVER} from "../services/globals";
import SearchComponent from '../components/search';
import User from "../components/user";
import React, { useState } from "react";
import { useRouter } from "next/router";
import { Queries } from "../services/queries";
import {ICart} from "../components/contracts/types";


 export default function MenuComponent({collections} ) {

  const base = `${WEBSERVER}/category`;
  const items = collections?.items ?? [];
  const router = useRouter();
  const [searchTerm, setSearchTerm] = useState("");
  //console.log("collections:", props.collections);
  //console.log("++++ props: " + JSON.stringify(items));
//console.log("FULL collections:", collections);
//console.log("items:", collections?.items);
//         items.forEach(i => {
//              console.log(i.name, "parent:", i.parent?.id, "children:", i.children?.length);
//          });


return (
    <nav className="navbar navbar-expand-md" aria-label="navbar">
      <div className="container-fluid">

        {/* Logo */}
        {/*<a className="navbar-brand" href={`${WEBSERVER}`}> 
          <img src={`${WEBSERVER}/logo.png`} className="logo-head" alt="Startseite" />
        </a>*/}

        {/* Toggler */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarsExample04"
          aria-controls="navbarsExample04"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Collapsible content */}
        <div className="collapse navbar-collapse" id="navbarsExample04">
          <ul className="navbar-nav me-auto mb-2 mb-md-0">

            {items
              .filter(item => item.parent?.id === "1") // Filter top-level items
              .map(item => (
                <li
                  key={item.id}
                  className={`nav-item ${item.children.length > 0 ? "dropdown" : ""}`}
                >
                  {item.children.length > 0 ? (
                    <>
                      <a
                        className="nav-link dropdown-toggle"
                        href="#"
                        id={`dropdown-${item.slug}`}
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        {item.name}
                      </a>

                      <ul className="dropdown-menu" aria-labelledby={`dropdown-${item.slug}`}>
                        {item.children.map(child => (
                          <li key={child.id} className="dropdown-item">
                            <a href={`${base}/${child.slug}`}>{child.name}</a>
                          </li>
                        ))}
                      </ul>
                    </>
                  ) : (
                    <a className="nav-link active" href={`${base}/${item.slug}`}>
                      {item.name}
                    </a>
                  )}
                </li>
              ))}
                <li>
                  <input
                    name="search"
                    className="searchinput"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        if (searchTerm && searchTerm.trim().length > 0) {
                          router.push(`/searchresult?q=${encodeURIComponent(searchTerm)}`);
                        }
                      }
                    }}
                    placeholder="Suche"
                  />
                  <i
                    className="bi-search fs-2"
                    title="Suche"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      if (searchTerm && searchTerm.trim().length > 0) {
                        router.push(`/searchresult?q=${encodeURIComponent(searchTerm)}`);
                      }
                    }}
                  ></i>
                </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

